var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 15.738C22.667 15.2771 22.667 15.0467 22.7363 14.8414C22.9379 14.2446 23.4694 14.0131 24.0018 13.7706C24.6003 13.4979 24.8995 13.3616 25.1961 13.3376C25.5327 13.3104 25.8699 13.383 26.1577 13.5444C26.5391 13.7584 26.8051 14.1652 27.0775 14.496C28.3354 16.0238 28.9642 16.7878 29.1943 17.6302C29.3801 18.3099 29.3801 19.0208 29.1943 19.7006C28.8587 20.9292 27.7983 21.9592 27.0134 22.9126C26.6119 23.4002 26.4111 23.644 26.1577 23.7863C25.8699 23.9478 25.5327 24.0203 25.1961 23.9931C24.8995 23.9691 24.6003 23.8328 24.0018 23.5602C23.4694 23.3176 22.9379 23.0862 22.7363 22.4894C22.667 22.284 22.667 22.0536 22.667 21.5927V15.738Z",
    stroke: "#808191",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 15.7381C9.33366 15.1579 9.31737 14.6363 8.84821 14.2283C8.67757 14.0799 8.45133 13.9768 7.99887 13.7707C7.40034 13.4981 7.10107 13.3619 6.80454 13.3379C5.91487 13.2659 5.43622 13.8731 4.92317 14.4963C3.66533 16.024 3.03641 16.7879 2.80627 17.6303C2.62057 18.3101 2.62057 19.0211 2.80627 19.7008C3.14193 20.9295 4.20235 21.9593 4.98727 22.9128C5.48205 23.5137 5.95469 24.062 6.80454 23.9933C7.10107 23.9693 7.40034 23.8329 7.99887 23.5604C8.45133 23.3543 8.67757 23.2512 8.84821 23.1028C9.31737 22.6948 9.33366 22.1733 9.33366 21.5929V15.7381Z",
    stroke: "#808191",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 14.0013V12.0013C26.6663 6.84665 21.8907 2.66797 15.9997 2.66797C10.1086 2.66797 5.33301 6.84665 5.33301 12.0013V14.0013",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 23.332C26.6667 29.332 21.3333 29.332 16 29.332",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.e5bbc4fa872f6914f929e76265d170bd.svg";
export { ForwardRef as ReactComponent };